import { useGetDashboardMessages } from "@/hooks/requests/dashboard/use-get-dashboard-messages";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { IonSkeletonText } from "@ionic/react";
import { memo } from "react";

export const GreetingHeader = memo(function GreetingHeader() {
  const { dashboardMessages, isLoading } = useGetDashboardMessages();

  return (
    <div
      className={cn(
        "fixed top-0 right-0 left-0 z-10 gap-5.5 px-9 pb-8",
        "pt-[calc(var(--safe-area-inset-top)+0.75rem)]",
        "bg-gradient-to-b from-white from-50% to-transparent",
        "flex items-center justify-between",
      )}
    >
      {isLoading ? (
        <IonSkeletonText animated className="h-10 w-full rounded-2xl" />
      ) : (
        <div className="flex min-w-0 flex-1 items-center gap-1">
          <h1 className={cn(textVariants.title3, "min-w-0 truncate whitespace-nowrap")}>
            {dashboardMessages?.greeting}
          </h1>
          <span className="flex-shrink-0">👋🏻</span>
        </div>
      )}
    </div>
  );
});
